import * as React from 'react';

import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
// @mui
import {
  Divider,
  Stack,
  Card,
  Typography,
  Box,
  Link,
  Avatar,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Chip,
  LinearProgress,
} from '@mui/material';
// routes
import { paths } from 'src/routes/paths';
// utils
import { fCurrency, fShortenNumber } from 'src/utils/formatNumber';
// types
import { ICourseProps } from 'src/types/course';
// components
import { useMutation } from '@tanstack/react-query';

import Image from 'src/components/image';
import Label from 'src/components/label';
import Iconify from 'src/components/iconify';
import TextMaxLine from 'src/components/text-max-line';
import { AiOutlineHeart, AiFillHeart } from 'react-icons/ai';
import { BsCart, BsCartFill } from 'react-icons/bs';
import { privateApi } from 'src/react-query';
import { CreateWishlistDto } from 'src/generated';

// ----------------------------------------------------------------------

type Props = {
  course: any;
  vertical?: boolean;
  length?: number;
  simClicked?: any;
};
const fetcherMyWish = () => privateApi.vod.wpVodControllerGetWishlist();
const fetcherAddMyWish = (params: CreateWishlistDto) =>
  privateApi.vod.wpVodControllerCreateWishlist(params);
const fetcherDelMyWish = (vodProductIdx: string) =>
  privateApi.vod.wpVodControllerDeleteWishlist(vodProductIdx);

export default function ElearningCourseItem({ course, vertical, length, simClicked }: Props) {
  /* eslint-disable */
  const [open, setOpen] = React.useState(false);
  const [Message, setMessage] = React.useState('');
  const [open2, setOpen2] = React.useState(false);

  const navigate = useNavigate();
  const { id, name, startdate, enddate, coverImg, status, allcount, count, remainingDuration } =
    course;
  const [wishList, setwishList] = useState<any[]>([]);

  const { mutate: mutateMyWish } = useMutation(() => fetcherMyWish(), {
    onSuccess: (e) => {
      // console.log(e)
      let list: any = [];
      if (e.data.header.isSuccess) {
        console.log(e.data.body.data);

        e.data.body.data.map((v: any) => {
          list.push(v.vodProductIdx);
        });
        console.log(list);
        setwishList(list);
      } else {
        if (e.data.header.resultCode == 403) {
          navigate('/auth/duplicated');
        }
        // message.error(e.data.header.resultMessage);
      }
    },
    onError: (e) => {
      console.log('login onError : ', e);
    },
  });
  const { mutate: AddWishList } = useMutation(
    (params: CreateWishlistDto) => fetcherAddMyWish(params),
    {
      onSuccess: (e) => {
        // console.log(e)
        let list: any = [];
        if (e.data.header.isSuccess) {
          console.log(e.data);
          setMessage('추가되었습니다.');
          setOpen(true);
          mutateMyWish();
        } else {
          if (e.data.header.resultCode == 403) {
            if (
              e.data.header.resultMessage ===
              '동일한 아이디로 중복 로그인하여, 자동으로 로그아웃 되었습니다.'
            ) {
              navigate('/auth/duplicated');
            }
          }
          setMessage(
            e.data.header.resultMessage === 'Unauthorized'
              ? '로그인이 필요합니다'
              : e.data.header.resultMessage
          );
          setOpen(true);
          // message.error(e.data.header.resultMessage);
        }
      },
      onError: (e) => {
        console.log('login onError : ', e);
      },
    }
  );
  const { mutate: DelWishList } = useMutation(
    (vodProductIdx: string) => fetcherDelMyWish(vodProductIdx),
    {
      onSuccess: (e) => {
        // console.log(e)
        let list: any = [];
        if (e.data.header.isSuccess) {
          console.log(e.data);
          setMessage('제거되었습니다.');
          setOpen(true);
          mutateMyWish();
        } else {
          if (e.data.header.resultCode == 403) {
            navigate('/auth/duplicated');
          }
        }
      },
      onError: (e) => {
        console.log('login onError : ', e);
      },
    }
  );

  useEffect(() => {
    if (sessionStorage.getItem('x-at') !== null) {
      mutateMyWish();
    }
  }, []);
  return (
    <Card
      sx={{
        display: { sm: 'flex' },
        '&:hover': {
          boxShadow: (theme) => theme.customShadows.z24,
        },
        ...(vertical && {
          flexDirection: 'column',
        }),
        margin: 'auto',
        width: length === 1 ? { sm: '33%' } : length === 2 ? { sm: '70%' } : { sm: '100%' },
      }}
    >
      <Box
        sx={{ flexShrink: { sm: 0 }, p: 1 }}
        onClick={() => {
          if (status === 0) {
            window.sessionStorage.setItem('myCourse', id);
            console.log(status);
            navigate('/e-learning/mycourse');
          } else if (status === 1 && !open) {
            console.log(status);
            setOpen(true);
            setMessage('수강 취소한 상품 입니다.');
          } else if (status === 8 && !open) {
            console.log(status);
            setMessage('휴강 상품 입니다.');

            setOpen(true);
          } else if (status === 9 && !open) {
            console.log(status);
            setOpen(true);
            setMessage('수강기간이 만료되었습니다.');
          }
        }}
      >
        {/* <Link component={RouterLink} to={`${paths.eLearning.course}?id=${id}`} color="inherit"> */}
        <Image
          alt={name}
          src={coverImg === null ? '/assets/images/course/course_1.jpg' : coverImg}
          sx={{
            borderRadius: 2,
            cursor: 'pointer',
            height: { md: 320, xs: 250 },
            objectFit: 'cover',
            width: { sm: 240, md: 320 },
            ...(vertical && {
              width: { sm: 1 },
            }),
          }}
          onClick={() => {}}
        />
        {/* </Link> */}
      </Box>

      <Stack
        spacing={1}
        sx={{ p: 3 }}
        // pb: {md: vertical ? 3 : 3 }}}
        width={'100%'}
      >
        <Stack
          spacing={{
            xs: 3,
            sm: vertical ? 3 : 1,
          }}
        >
          {/* 카테고리랑 가격 */}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ my: { xs: -3, md: vertical ? -1.5 : 0 } }}
          >
            {status === 0 && <Chip color="success" label={'수강'} />}
            {status === 1 && <Chip color="error" label={'수강취소'} />}
            {status === 8 && <Chip color="info" label={'휴강'} />}
            {status === 9 && <Chip color="info" label={'종강'} />}
            <Typography variant="overline" sx={{ color: 'primary.main' }}>
              {enddate === '무제한' ? enddate : `${startdate}~${enddate}`}
            </Typography>
          </Stack>
          {/* 제목 */}
          <Stack spacing={1}>
            <Stack sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Link
                component={RouterLink}
                to={`${paths.eLearning.course}?id=${id}`}
                color="inherit"
              >
                <TextMaxLine
                  variant="h6"
                  line={1}
                  onClick={() => {
                    console.log(id);
                    if (window.location.pathname === '/e-learning/course') {
                      simClicked(true);
                    }

                    window.sessionStorage.setItem('Product', id);
                  }}
                >
                  {name}
                </TextMaxLine>
              </Link>

              {/* {
              wishList.includes(id) ?        
            <BsCartFill style={{cursor :"pointer" , color : "red"}} onClick={()=>{
              DelWishList(id)
            }}></BsCartFill>
:          
  <BsCart style={{cursor :"pointer"}}
  onClick={()=>{
    // DelWishList(id)
    AddWishList({
      vodProductIdx : Number(id)
    })
  }}
  ></BsCart>

            } */}
              {/* <AiFillHeart style={{cursor :"pointer" , color : "red"}}></AiFillHeart>
            <AiOutlineHeart style={{cursor :"pointer"}}></AiOutlineHeart> */}
            </Stack>

            {/* <TextMaxLine
              variant="body2"
              color="text.secondary"
              sx={{
                ...(vertical && {
                  display: { sm: 'none' },
                }),
              }}
            >
              <div dangerouslySetInnerHTML={{ __html: description as string }}/>

          
            </TextMaxLine> */}
            <Stack
              sx={{
                display: 'flex',
                flexWrap: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                boxSizing: 'inherit',
              }}
            >
              <LinearProgress
                value={(count / allcount) * 100}
                variant="determinate"
                aria-label="aa"
              />
              <Typography sx={{ fontSize: { md: 14, xs: 11 } }}>
                {Math.round((count / allcount) * 100)} %
              </Typography>
            </Stack>
          </Stack>
        </Stack>

        {/* <Stack direction="row" alignItems="center">
          <Avatar src={teachers[0]?.picture} />

          <Typography variant="body2" sx={{ ml: 1, mr: 0.5 }}>
            {teachers[0]?.name}
          </Typography>

          {teachers?.length > 1 && (
            <Link underline="always" color="text.secondary" variant="body2">
              + {teachers?.length - 1} teachers
            </Link>
          )}
        </Stack> */}

        {/* <Divider
          sx={{
            borderStyle: 'dashed',
            display: { sm: 'none' },
            ...(vertical && {
              display: 'block',
            }),
          }}
        /> */}

        <Stack
          direction="row"
          flexWrap="wrap"
          alignItems="center"
          sx={{ color: 'text.disabled', '& > *:not(:last-child)': { mr: 2.5 } }}
        >
          {/* <Stack direction="row" alignItems="center" sx={{ typography: 'body2' }}>
            <Iconify icon="carbon:time" sx={{ mr: 1 }} /> {`${totalHours}`}
          </Stack> */}
        </Stack>
        <Divider
          sx={{
            borderStyle: 'dashed',
            py: 1.4,
          }}
        />
        <Stack
          direction={'row'}
          sx={{ gap: 2, display: 'flex', justifyContent: 'center', pl: { md: vertical ? 1 : 0 } }}
        >
          <div style={{ width: '100%' }}>
            <Button
              size="large"
              variant="soft"
              color="success"
              style={{ width: '100%' }}
              onClick={() => {
                if (status === 0) {
                  window.sessionStorage.setItem('myCourse', id);
                  console.log(status);
                  navigate('/e-learning/mycourse');
                } else if (status === 1 && !open) {
                  console.log(status);
                  setOpen(true);
                  setMessage('수강 취소한 상품 입니다.');
                } else if (status === 8 && !open) {
                  console.log(status);
                  setMessage('휴강 상품 입니다.');

                  setOpen(true);
                } else if (status === 9 && !open) {
                  console.log(status);
                  setOpen(true);
                  setMessage('수강기간이 만료되었습니다.');
                }
              }}
            >
              수업 참여하기
            </Button>
          </div>
        </Stack>
      </Stack>

      <Dialog
        fullWidth
        onClose={() => {
          setOpen(false);
        }}
        open={open}
      >
        <DialogContent>
          <div
            style={{ height: 100, display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          >
            <Typography variant="h5">{Message}</Typography>
          </div>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              setOpen(false);
              if (Message === '로그인이 필요합니다') {
                navigate('/auth/login-cover');
              }
              // console.log("ss")
            }}
          >
            확인
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        onClose={() => {
          setOpen2(false);
        }}
        open={open2}
      >
        <DialogContent>
          <div
            style={{
              height: 90,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'flex-end',
              // paddingTop: '50px',
            }}
          >
            <Typography variant="h5">로그인이 필요합니다</Typography>
          </div>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              setOpen2(false);
              sessionStorage.setItem('history', window.location.pathname);

              navigate('/auth/login-cover');
            }}
          >
            확인
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
}
